function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import isEqual from "lodash/isEqual";
import { Checkbox } from "./Checkbox";
import { View } from "./View";
import { AccessibleInput } from "../hooks/useAccessibleInput";
import { useTheme } from "../styles";
function RadioInput(_param) {
    var disabled = _param.disabled, horizontal = _param.horizontal, items = _param.items, onChangeValue = _param.onChangeValue, value = _param.value, innerStyle = _param.innerStyle, labelSize = _param.labelSize, labelSpacing = _param.labelSpacing, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'radio' : _param_variant, props = _object_without_properties(_param, [
        "disabled",
        "horizontal",
        "items",
        "onChangeValue",
        "value",
        "innerStyle",
        "labelSize",
        "labelSpacing",
        "variant"
    ]);
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(AccessibleInput, _object_spread_props(_object_spread({}, props), {
        labelSize: labelSize === 'large' ? 21 : undefined,
        labelLineHeight: labelSize === 'large' ? 28 : undefined,
        children: function(accessibleProps) {
            var _props_spacing;
            return /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({}, accessibleProps), {
                role: "radiogroup",
                spacing: (_props_spacing = props.spacing) !== null && _props_spacing !== void 0 ? _props_spacing : theme.checkbox.optionSpacing,
                row: horizontal,
                style: [
                    {
                        marginLeft: 16
                    },
                    horizontal ? {
                        minHeight: 50
                    } : null,
                    innerStyle,
                    labelSize === 'large' ? {
                        marginTop: (labelSpacing !== null && labelSpacing !== void 0 ? labelSpacing : 20) - 5
                    } : null
                ],
                testID: props.testID,
                children: items.map(function(item, i) {
                    var isSelected = Array.isArray(value) ? value.includes(item.value) : isEqual(value, item.value);
                    var _props_optionLabelWeight;
                    return /*#__PURE__*/ _jsxs(View, {
                        style: isSelected ? [
                            item.style,
                            item.selectedStyle
                        ] : item.style,
                        spacing: 10,
                        children: [
                            /*#__PURE__*/ _jsx(Checkbox, {
                                disabled: disabled,
                                value: isSelected,
                                onChangeValue: function() {
                                    if (Array.isArray(value)) {
                                        if (isSelected) {
                                            onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(value.filter(function(v) {
                                                return v !== item.value;
                                            }));
                                        } else {
                                            onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(_to_consumable_array(value).concat([
                                                item.value
                                            ]));
                                        }
                                    } else {
                                        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(item.value);
                                    }
                                },
                                variant: variant !== null && variant !== void 0 ? variant : 'radio',
                                label: item.label,
                                "aria-label": item['aria-label'],
                                labelWeight: (_props_optionLabelWeight = props.optionLabelWeight) !== null && _props_optionLabelWeight !== void 0 ? _props_optionLabelWeight : props.labelWeight,
                                horizontal: true,
                                testID: props.testID ? "".concat(props.testID, "_choice_").concat(i) : undefined
                            }),
                            isSelected ? item.selectedChild : item.unselectedChild
                        ]
                    }, item.key || ([
                        'string',
                        'boolean',
                        'number'
                    ].includes(_type_of(item.value)) ? item.value.toString() : typeof item.label === 'string' ? item.label : i.toString()));
                })
            }));
        }
    }));
}
export { RadioInput };
/**
 * @deprecated Prefer named export
 */ export default RadioInput;
